<!-- 查看公钥弹窗 -->
<template>
  <el-dialog
    class="see-cert-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <detail-section title="通信公钥" :show-border="true">
      <div class="info-content">{{ communication }}</div>
    </detail-section>

    <detail-section title="签名公钥" :show-border="true">
      <div class="info-content">
        <el-row class="sign-info">
          <el-col
            v-for="(item, kIndex) in dataMeta"
            :key="kIndex"
            class="sign-info-item"
            :span="12"
          >
            <span class="sign-info-item-label">{{ item.label }}</span
            >：
            <span class="sign-info-item-content">{{ data[item.prop] || $constants.EMPTY }}</span>
          </el-col>
        </el-row>
        <el-divider v-if="dataMeta && dataMeta.length > 0"></el-divider>
        <div>{{ sign }}</div>
      </div>
    </detail-section>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleOk()">下载</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SeeDialog',
  data() {
    return {
      title: '',
      dialogVisible: false,
      sign: '', //签名内容
      communication: '', //通信内容
      rowData: null,
      index: '',
      id: '',
      data: {},
      dataMeta: []
    }
  },
  methods: {
    handleCancel() {
      this.sign = ''
      this.communication = ''
      this.rowData = null
      this.id = ''
      this.name = ''
      this.index = ''
      this.dataMeta = []
      this.dialogVisible = false
    },
    handleOpen(data, dataMeta) {
      this.data = data
      this.sign = data.sign
      this.communication = data.communication
      this.id = data.id
      this.index = data.index
      this.name = data.name
      this.dataMeta = dataMeta || []

      this.rowData = data
      this.title = data.title
      this.dialogVisible = true
    },
    handleOk() {
      const nameSign = this.id + this.index + this.name + '签名.key'
      const nameCommunication = this.id + this.index + this.name + '通信.key'
      this.$utils.createFileAndDownload(nameSign, this.sign)
      this.$utils.createFileAndDownload(nameCommunication, this.communication)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme(
  'see-cert-dialog',
  (
    --see-cert-dialog-info-content-detail-item-color: #fff,
    --see-cert-dialog-info-content-detail-item-label-color: #a5b3b9
  ),
  (
    --see-cert-dialog-info-content-detail-item-color: #192227,
    --see-cert-dialog-info-content-detail-item-label-color: #5a6973
  )
);
.see-cert-dialog.common-dialog {
  @include adaptation(
    (
      --see-cert-dialog-width: 800px,
      --see-cert-dialog-info-content-item-small-max-height: 180px,
      --see-cert-dialog-info-content-item-max-height: 240px,
      --see-cert-dialog-info-content-padding: 24px,
      --see-cert-dialog-info-content-line-height: 27px
    )
  );
  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  .info-content {
    max-height: var(--see-cert-dialog-info-content-item-small-max-height);
    padding: var(--see-cert-dialog-info-content-padding);
    overflow-y: auto;
    line-height: var(--see-cert-dialog-info-content-line-height);
  }

  .sign-info-item {
    color: var(--see-cert-dialog-info-content-detail-item-color);
    .sign-info-item-label {
      color: var(--see-cert-dialog-info-content-detail-item-label-color);
    }
  }
}
</style>
